import * as React from "react"

import { cn } from "../../lib/utils"

const sanitizeId = (raw) => (raw ? raw.replace(/[^a-zA-Z0-9_-]/g, "") : "")

const Textarea = React.forwardRef(({ className, id, name, ...props }, ref) => {
  const autoId = sanitizeId(React.useId())
  const resolvedId = id || `textarea-${autoId}`
  const resolvedName = name || id || `textarea-${autoId}`
  return (
    <textarea
      id={resolvedId}
      name={resolvedName}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
